import { CalendarPickerView } from '@mui/x-date-pickers';

export const CALENDAR_VIEWS: CalendarPickerView[] = ['day'];

export const DIALOG_POPOVER_ELEVATION = 24;
